var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"home-button",attrs:{"to":"/register","tag":"div"}},[_c('v-btn',{staticClass:"px-4 text-capitalize"},[_vm._v("\n        Зарегистрироваться\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }